var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-toolbar",
        { attrs: { dark: "", color: "primary", fixed: "" } },
        [
          _c(
            "v-btn",
            {
              attrs: { icon: "", dark: "", disabled: _vm.isLoading },
              on: { click: _vm.handleCerrarClick }
            },
            [_c("v-icon", [_vm._v("close")])],
            1
          ),
          _c("v-toolbar-title", [_vm._v(_vm._s(_vm.titulo))]),
          _c("v-spacer"),
          _c("v-toolbar-items", [_vm._t("default")], 2)
        ],
        1
      ),
      _c("br"),
      _c("br"),
      _c("br")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }